module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#detail6_1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES33UC14']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detail6_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC11']['160']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodinput),
      expression: "descCodinput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codinput",
      "name": "coddesc_codinput",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodinput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodinput = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC11']['10']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodempid),
      expression: "descCodempid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodempid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodempid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-6 col-sm-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES33UC11']['20']))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "dtereq",
      "name": "dtereq",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.setDateOutput(_vm.detail.detail.dtereq)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC11']['40']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab6Table1,
      "data": _vm.detail.table1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES33UC11']['50']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab6Table2,
      "data": _vm.detail.table2
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.buttonLabels['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76fb646c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres33u/detail6.vue
// module id = 3896
// module chunks = 1